<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h3>{{$t('pages.RegisterUser')}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                        <form @submit="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="registration"/>
                            <button
                                    type="submit"
                                    :class="(disabled ? 'disabled': '') +' btn btn-primary mt-4 float-right'"
                                    :disabled="disabled"
                            >{{ $t('button.Send') }}
                            </button>
                        </form>
                        <vue-recaptcha
                                :sitekey="siteKey"
                                @expired="onExpired"
                                @verify="onVerify"
                                ref="recaptcha"
                                size="invisible"
                        ></vue-recaptcha>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import validation from '../../utils/preDefinedValidation';
  import {mapActions} from 'vuex';
  import {ERROR_MESSAGES, SITE_KEY_RECAPTCHA} from '../../constants';
  import VueRecaptcha from 'vue-recaptcha';
  import dayjs from 'dayjs';

  export default {
    name: 'RegistrationForm',
    components: {VueRecaptcha},
    data() {
      return {
        siteKey: SITE_KEY_RECAPTCHA,
        disabled: false,
        error: '',
        form: {},
        model: {
          avatar: '',
          firstName: '',
          lastName: '',
          nick: '',
          birthDate: '',
          phone: '',
          email: '',
          city: '',
          password: '',
          password_confirmation: ''
        },
        fields: [
          {
            key: 'avatar',
            type: 'image',
            templateOptions: {
              label: this.$t('fields.Avatar'),
              atts: {
                name: 'avatar'
              },
              class: 'col-4 m-auto'
            },
            required: false
          },
          {
            key: 'firstName',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.FirstName'),
              atts: {
                name: 'first-name'
              },
              onBlur: function (e) {
                this.model.firstName = e.target.value.capitalize();
              }
            },
            required: true,
            validators: {
              valid: validation.validString
            }
          },
          {
            key: 'lastName',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.LastName'),
              atts: {
                name: 'last-name'
              },
              onBlur: function (e) {
                this.model.lastName = e.target.value.capitalize();
              }
            },
            required: true,
            validators: {
              valid: validation.validString
            }
          },
          {
              key: 'nick',
              type: 'input',
              templateOptions: {
                  label: this.$t('fields.Nick'),
                  atts: {
                      name: 'nick'
                  },
                  onBlur: function (e) {
                      this.model.nick = e.target.value.capitalize();
                  }
              },
              required: true,
              validators: {
                  valid: validation.validString
              }
          },
          {
            key: 'birthDate',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.BirthDate'),
              placeholder: this.$t('fields.BirthDate')
            },
            required: true
          },
          {
            key: 'sex',
            type: 'multi-select',
            options: [{
              value: 'f',
              label: this.$t('registration.sex.female')
            }, {
              value: 'm',
              label: this.$t('registration.sex.male')
            }],
            templateOptions: {
              label: this.$t('fields.Sex'),
              multiple: false,
              closeOnSelect: true
            },
            required: true
          },
          {
            key: 'phone',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.PhoneNumber'),
              atts: {
                name: 'phone'
              }
            },
            required: true,
            validators: {
              valid: validation.validPhone
            }
          },
          {
            key: 'email',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Email'),
              atts: {
                name: 'email'
              }
            },
            required: true,
            validators: {
              valid: validation.validEmail
            }
          },
          {
              key: 'email_confirmation',
              type: 'input',
              templateOptions: {
                  label: this.$t('fields.EmailConfirm'),
                  atts: {
                      name: 'email-confirmation'
                  }
              },
              required: true,
              validators: {
                  valid: validation.validConfirmationEmail
              }
          },
          {
            key: 'city',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.City'),
              atts: {
                name: 'city'
              },
              onBlur: function (e) {
                this.model.city = e.target.value.capitalize();
              }
            },
            required: true,
            validators: {
              valid: validation.validString
            }
          },
          {
            key: 'password',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Password'),
              inputType: 'password',
              atts: {
                name: 'password'
              }
            },
            required: true,
            validators: {
              valid: validation.validPassword
            }
          },
          {
            key: 'password_confirmation',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.ConfirmPassword'),
              inputType: 'password',
              atts: {
                name: 'password-confirmation'
              }
            },
            required: true,
            validators: {
              valid: validation.validConfirmationPassword
            }
          },
          {
            key: 'terms_and_condition',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.GDPR'),
              atts: {
                name: 'terms_and_condition'
              }
            },
            validators: {
              valid: validation.needToBeTrue
            }
          },
          {
            key: 'newsletter',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.newsletter'),
              atts: {
                name: 'newsletter'
              }
            }
          }
        ]
      };
    },
    methods: {
      ...mapActions(['registerUser']),
      submit(e) {
        e.preventDefault();
        this.error = null;
        this.$refs.registration.validate()
          .then(() => {
            if (!this.form.$valid) return;
            this.disabled = true;
            this.$refs.recaptcha.execute();
          });
      },
      onExpired() {
        this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
      },
      onVerify(recaptcha) {
        const {password, password_confirmation, firstName, lastName, email, email_confirmation, nick, phone, city} = this.model
        var data = {
          password,
          password_confirmation,
          firstName,
          lastName,
          nick,
          email,
          email_confirmation,
          phone,
          city,
          terms_and_condition: true,
          recaptcha,
        };

        data.sex = this.model.sex ? this.model.sex.value : null;

        if (this.model.avatar && this.model.avatar.length){
          data.avatar = this.model.avatar;
        }
        if (this.model.newsletter)  {
          data.newsletter = this.model.newsletter;
        }

        data.birthDate = dayjs(this.model.birthDate)
          .format('YYYY-MM-DD');
        this.registerUser(data)
          .then(
            () => {
              this.$router.push({name: 'registrationSuccess'});
            },
            e => {
              this.$refs.recaptcha.reset();
              this.disabled = false;
              if (e.response && e.response.data && e.response.data.message) {
                this.error = 'errorMessages.' + e.response.data.message;
              } else {
                if (e.response && e.response.status === 400) {
                  this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
                } else {
                  this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
                }
              }
            }
          );
      }
    }
  };
</script>

<style scoped>
</style>
